import useDecodedPromoCode from './useDecodedPromoCode';

export default useDecodedPromoCode;
